import { SONSTIGES } from '@/constants/werkzeugverwaltung/abmusterung/grund';
import { DateTime } from 'luxon';

export const abmusterungAbteilung = {
  key: 'abmusterungabteilung',
  label: 'Abteilung',
  formatter: (value) => value?.name,
  sortable: true,
  sortKey: 'abmusterung_abteilung.name',
};

export const grundAbmusterung = {
  key: 'grund_abmusterung',
  label: 'Grund',
  formatter: (value, key, item) => {
    if (value?.id === SONSTIGES && item?.grund_abmusterung_erlaeuterung) {
      return `${value?.name} (${item?.grund_abmusterung_erlaeuterung})`;
    }
    return value?.name;
  },
};

export const grundAbmusterungBemerkung = {
  key: 'grund_abmusterung_bemerkung',
  label: 'Bem. Grund',
};

export const abmusterungsauftragsnummer = {
  key: 'abmusterungsauftragsnummer',
  label: 'Abm-Nr.',
};
export const artikelbezeichnung = {
  key: 'artikelbezeichnung',
  label: 'Artikelbezeichnung',
};

export const artikelnummer = {
  key: 'artikelnummer',
  label: 'Artikel-Nr.',
};

export const fertigungsauftagsnummer = {
  key: 'fertigungsauftagsnummer',
  label: 'FA-Nr.',
};

export const zeichungsnummer = {
  key: 'zeichnung_nummer',
  label: 'Zeichnungs-Nr.',
};

export const zeichungsindex = {
  key: 'zeichnung_index',
  label: 'Zeichnungs-Idx.',
};

export const datumFaelligkeit = {
  key: 'kundenauftrag_faelligkeit',
  label: 'Fälligkeit',
  sortable: true,
  formatter: (value) => (value ? DateTime.fromMillis(value).toFormat('dd.MM.yyyy') : null),
};

export const unterschriftQsDate = {
  key: 'unterschrift_qs_date',
  label: 'Freigabedatum QS',
  sortable: true,
  formatter: (value) => (value ? DateTime.fromMillis(value).toFormat('dd.MM.yyyy HH:mm') : null),
};

export const kundenfreigabeAngefragtDate = {
  key: 'kundenfreigabe_angefragt_am',
  label: 'Letzte Anfrage an Kunden',
  sortable: true,
  formatter: (value) => (value ? DateTime.fromMillis(value).toFormat('dd.MM.yyyy HH:mm') : null),
};

export const status = {
  key: 'status',
  label: 'Status',
  formatter: (value, key, item) => {
    if (item.abmusterung_abgeschlossen) {
      return 'Abgeschlossen';
    } if (item.intern === false && item.unterschrift_qs_date) {
      return 'Warte auf Kunde';
    } if (item.dokumentation_abgeschlossen) {
      return 'Warten auf Freigabe (intern)';
    } if (item.abfragen_abgeschlossen) {
      return 'In Durchführung / Dokumentation';
    } if (item.entwicklung_abgeschlossen) {
      return 'Abfragen vor Abmusterung';
    }
    return 'In Entwicklung';
  },
};

export const standardFields = [
  abmusterungAbteilung,
  grundAbmusterung,
  grundAbmusterungBemerkung,
  abmusterungsauftragsnummer,
  artikelbezeichnung,
  artikelnummer,
  fertigungsauftagsnummer,
  zeichungsnummer,
  zeichungsindex,
  status,
  datumFaelligkeit,
];
